import React, { useContext, useEffect, useState, useCallback } from 'react';
import { get, isEqual, isNil, truncate } from 'lodash';
import { useHistory } from 'react-router-dom';
import { IconButton, AppBar, Toolbar } from '@material-ui/core';
import { PeopleOutline } from '@material-ui/icons';
import logo from './assets/logoWithWord.png';
import AccountContext from './context/accountContext';
import { useWeb3React } from '@web3-react/core';

import { StyledButton, StyledTypography, Row } from './style/generalStyle';
import { ProfileMenu } from './components/ProfileMenu';
import WalletConnectModal from './components/WalletConnectModal';
import useConnect2Phantom from './components/PhantomConnectModal.tsx';

export const SimpleNavigationBar = () => {
  const [open, setOpen] = useState(false);

  const { account: ethAddress } = useWeb3React();
  const { solAddress } = useConnect2Phantom();

  const { currentAddress, account, refreshAccount, setCurrentAddress } =
    useContext(AccountContext);
  const history = useHistory();
  const [anchorMenu, setAnchorMenu] = useState(null);

  const onOpenMenu = (event) => {
    setAnchorMenu(event.target);
  };

  const onLogin = useCallback(
    async (address) => {
      await refreshAccount(address);
      localStorage.setItem('address', address);
      history.push('/allowlist');
    },
    [history, refreshAccount]
  );

  useEffect(() => {
    const existedAddress = get(account, 'mainAddress');

    if (!isNil(ethAddress) && !isEqual(existedAddress, ethAddress)) {
      onLogin(ethAddress);
    }
    if (!isNil(solAddress) && !isEqual(existedAddress, solAddress)) {
      onLogin(solAddress.toString());
    }
  }, [ethAddress, solAddress, account, onLogin]);

  useEffect(() => {
    const localAddress = localStorage.getItem('address');

    if (localAddress !== 'null' && isNil(currentAddress)) {
      onLogin(localAddress);
    }

    if (!isNil(get(account, 'mainAddress'))) {
      setCurrentAddress(get(account, 'mainAddress'));
    }
  }, [account, setCurrentAddress, currentAddress, onLogin]);

  return (
    <AppBar
      position="fixed"
      style={{
        background: 'black',
        boxShadow: 'none',
      }}
    >
      <Toolbar
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          zIndex: 10,
          width: '100%',
          padding: 0,
        }}
      >
        <Row>
          <img
            src={logo}
            alt="Premint"
            style={{
              height: 60,
              padding: '1.5rem',
              marginRight: '1rem',
            }}
            onClick={() => {
              history.push('/allowlist');
            }}
          />
        </Row>

        {isNil(currentAddress) ? (
          <Row style={{ justifyContent: 'flex-end' }}>
            <StyledButton
              onClick={() => {
                setOpen(true);
              }}
            >
              Login
            </StyledButton>
          </Row>
        ) : (
          <Row style={{ justifyContent: 'flex-end' }}>
            <StyledTypography>
              {truncate(currentAddress, { length: 10 })}
            </StyledTypography>
            <IconButton onClick={onOpenMenu} style={{ color: ' #cf5059' }}>
              <PeopleOutline />
            </IconButton>
            <ProfileMenu
              anchorMenu={anchorMenu}
              setAnchorMenu={setAnchorMenu}
            />
          </Row>
        )}
      </Toolbar>
      <WalletConnectModal isOpen={open} closeModal={() => setOpen(false)} />
    </AppBar>
  );
};
